<template lang="pug">
div.padding.p-t-0.table-filters
    div.row
        div.col-md-3
            div.m-b-sm.p-t-sm
                h5.m-b-md._300 Stock Count Variance

        div.col-md-9
            div.row
                div.col-md-3.m-y-sm.filter
                    select.form-control.c-select(
                            v-model="filter.variance",
                            @change="setTypeFilter"
                        )
                            option(:value="null") Filter Variance Reason
                            option(:value="variance.id", v-for="variance in varianceTypes") {{ variance.name }}

    div.row
        div.col-xs-12
            div.box
                v-server-table(
                    :url="api",
                    :name="tableName",
                    ref="datatable",
                    :columns="columns",
                    :options="options"
                )
</template>

<script>
import { mapGetters } from 'vuex';
import stockCheckMixin from './stock-check-mixin';
import stockCheckEvent from './stock-check-event';
const exportUrl = 'stock_checks.export_variance';

export default {
    mixins: [stockCheckMixin],

    data() {
        var that = this;

        return {
            filter: {
                variance: null,
            },
            columns: [
                'stock',
                'sku',
                'barcode',
                'outlet',
                'variance',
                'variance_type',
            ],
            options: {
                useReportFilter: true,
                customFilters: ['outlet_id', 'since', 'until', 'type'],
                headings: {
                    variance_type: 'Variance Reason',
                },
                templates: {
                    variance(h, row) {
                        return `${row.variance}`;
                    },

                    variance_type: (h, row) => {
                        const variance = this.varianceTypes.find(
                            vt => vt.id == row.variance_type,
                        );
                        return variance.name;
                    },
                },
                csv_url: Laroute.route(exportUrl, { type: 'csv' }),
                pdf_url: Laroute.route(exportUrl, { type: 'pdf' }),
                xls_url: Laroute.route(exportUrl, { type: 'xlsx' }),
            },
        };
    },

    computed: {
        api() {
            return Laroute.route('stock_checks.variance');
        },

        tableName() {
            return 'VUETABLE_STOCK_CHECK_VARIANCE';
        },

        ...mapGetters('stockCheck', ['varianceTypes']),
    },

    mounted() {
        stockCheckEvent.$on('applyDateFilter', date => {
            this.$refs.datatable.applyDateFilter(date);
        });
    },

    methods: {
        setTypeFilter(e) {
            this.$store.commit(`${this.tableName}/SET_CUSTOM_FILTER`, {
                filter: 'type',
                value: this.filter.variance,
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/stock_check/stock-check-variance.vue